var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('Head'),_c('Banner'),_c('HeaderNav',{attrs:{"data":_vm.headerNavigation}}),_c('div',{staticClass:"app-main"},[_c('router-view')],1),_c('Blogroll'),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }